module.exports = __webpack_public_path__ + "static/media/001.3d32b439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/001.jpg
// module id = 474
// module chunks = 0